import fetch from '../utils/fetch'

export function getMemberPoint (query) {
  return fetch({
    url: '/point/member',
    method: 'get',
    params: query
  })
}

export function getPointCountIndex (query) {
  return fetch({
    url: '/member/pointcount/index',
    method: 'get',
    params: query
  })
}

export function adjustmentPoint (query) {
  return fetch({
    url: '/point/adjustment',
    method: 'post',
    data: query
  })
}

// ============== 会员积分任务相关接口 ==============

// 获取任务列表
export function getTaskList (params) {
  return fetch({
    url: '/member/points/task/list',
    method: 'get',
    params
  })
}

// 创建任务
export function createTask (data) {
  return fetch({
    url: '/member/points/task/create',
    method: 'post',
    data
  })
}

// 更新任务
export function updateTask (data) {
  return fetch({
    url: '/member/points/task/update',
    method: 'put',
    data
  })
}

// 删除任务
export function deleteTask (params) {
  return fetch({
    url: '/member/points/task/delete',
    method: 'delete',
    params
  })
}

// 获取任务详情
export function getTaskDetail (params) {
  return fetch({
    url: '/member/points/task/info',
    method: 'get',
    params
  })
}
